// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from './request'
const serveName = process.env.VUE_APP_SERVENAME

// 查询阈值方案
export const getThresholdPlanListFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/getThresholdSchemeList`, null, 'POST_JSON', data)

// 新增/修改阈值方案
export const upsertThresholdPlanFetch = (data: object) =>
  request(`/${serveName}/bizMonitor/addThresholdScheme`, null, 'POST_JSON', data)

// 删除阈值方案
export const deleteThresholdPlanFetch = (data: object) =>
  request(`/${serveName}/bizMonitor/deleteThresholdScheme`, null, 'POST_JSON', data)

// 查询阈值指标
export const getIndicatorSettingListFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/getThresholdIndicatorList`, null, 'POST_JSON', data)

// 修改阈值指标
export const saveIndicatorSettingFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/addThresholdIndicator`, null, 'POST_JSON', data)

// 查询预警任务
export const getWarningTaskListFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/getWarningTaskList`, null, 'POST_JSON', data)

// 校验飞书群聊名称有效性
export const validateFeishuChatInfoFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/validateFeishuChatInfo`, null, 'POST_JSON', data)

// 查询指标类型
export const getMetricTypeListFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/getAllIndicatorTypes`, null, 'POST_JSON', data)

// 新增/修改预警任务
export const upsertWarningTaskFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/addWarningTask`, null, 'POST_JSON', data)

// 删除预警任务
export const deleteWarningTaskFetch = (data?: object) =>
  request(`/${serveName}/bizMonitor/deleteWarningTask`, null, 'POST_JSON', data)
